import { render, staticRenderFns } from "./CommonFormWithDeliveryFlatRate.vue?vue&type=template&id=134a590c&lang=pug&"
import script from "./CommonFormWithDeliveryFlatRate.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithDeliveryFlatRate.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithDeliveryFlatRate.vue?vue&type=style&index=0&id=134a590c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports